<template>
  <div id="app">
    <div aria-live="polite" aria-atomic="true" class="sr-only" id="app-status-region" />
    <BootStatusBanner />
    <AppLoadingBar />
    <RouterView />
    <ToastContainer />
  </div>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router'
import ToastContainer from '@/components/shared/ToastContainer.vue'
import AppLoadingBar from '@/components/layout/AppLoadingBar.vue'
import BootStatusBanner from '@/components/layout/BootStatusBanner.vue'
import { initThemeFromStorage } from '@/composables/useTheme'

initThemeFromStorage()
</script>

<style>
#app {
  min-height: 100vh;
  background-color: #f4f5f7;
}

.dark #app {
  background-color: #0a0a0a;
}
</style>
